// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { PathologyOrderGetAllResponse } from '@quromedical/models';
import { Col } from 'components/base';
import { ColumnType } from 'components/table';
import { getDisplayDate } from 'core/display';
import { Text } from 'design-system';
import React from 'react';
import { strings } from 'strings';

interface PathologyOrderTable {
  orderNumber: string;
  requestStatus: string;
  sampleDate: string;
  tests: string[];
  comment: string;
  id: string;
  copyDoctors: string[];
}

export const serviceRequestColumns: ColumnType<PathologyOrderTable>[] = [
  {
    header: strings.PathologyOrderNumberSubheading,
    accessor: 'orderNumber',
  } as ColumnType<PathologyOrderTable, 'orderNumber'>,
  {
    header: strings.PathologySampleSubheading,
    accessor: 'sampleDate',
  } as ColumnType<PathologyOrderTable, 'sampleDate'>,
  {
    header: strings.PathologyRequestStatusSubheading,
    accessor: 'requestStatus',
  } as ColumnType<PathologyOrderTable, 'requestStatus'>,
  {
    header: strings.PathologyTestsSubheading,
    Cell: ({ value = [] }) => (
      <Col>
        {value.map(test => (
          <Text>{test || strings.DisplayNotFound}</Text>
        ))}
      </Col>
    ),
    accessor: 'tests',
  } as ColumnType<PathologyOrderTable, 'tests'>,
  {
    header: strings.PathologyNotesSubheading,
    accessor: 'comment',
  } as ColumnType<PathologyOrderTable, 'comment'>,
  {
    header: strings.PathologyCopiedDoctorsSubheading,
    Cell: ({ value = [] }) => (
      <Col>
        {value.map(practitioner => (
          <Text>{practitioner || strings.DisplayNotFound}</Text>
        ))}
      </Col>
    ),
    accessor: 'copyDoctors',
  } as ColumnType<PathologyOrderTable, 'copyDoctors'>,
];

export const getDataFromResponse = (
  res: PathologyOrderGetAllResponse
): Partial<PathologyOrderTable>[] => {
  return res.orders.map(order => ({
    id: order.id,
    orderNumber: order.orderNumber,
    requestStatus: order.status,
    sampleDate: getDisplayDate(order.sampleDateTime),
    tests: order.testCodes?.map(code => code.display || strings.DisplayNotFound),
    comment: order.comment,
    copyDoctors: order.copyDoctors?.map(
      practitioner => practitioner.display || strings.DisplayNotFound
    ),
  }));
};
